import * as React from "react";
import { FeedElementStats } from "../../../server/feed/buildfeed";
import { FeedPanel } from "../DesignSystem/formatting/FeedComponents";
import { RLink } from "../DesignSystem/RLink";

export const FeedElementStatsJSX = ({ stats }: { stats: FeedElementStats }) => {
  let sortedStats = stats.stats;
  if (sortedStats.length === 0) {
    return <div></div>;
  }

  sortedStats = sortedStats.sort((a, b) => {
    return (
      Number(a.downloads) +
      Number(a.plays) -
      (Number(b.downloads) + Number(b.plays))
    );
  });

  return (
    <FeedPanel title={<>Weekly Stats</>}>
      {sortedStats.map((entry) => (
        <div className="flex items-center justify-between py-1" key={entry.entry_id}>
          <RLink to={`/entry/${entry.entry_id}`}>{entry.entry_title}</RLink>

          <div className="flex items-center gap-3 text-sm text-slate-500 dark:text-slate-400">
            <span className="flex items-center gap-1">
              {entry.plays}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path d="M6.3 2.84A1.5 1.5 0 0 0 4 4.11v11.78a1.5 1.5 0 0 0 2.3 1.27l9.344-5.891a1.5 1.5 0 0 0 0-2.538L6.3 2.841Z" />
              </svg>
            </span>
            <span className="flex items-center gap-1">
              {entry.downloads}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
              </svg>
            </span>
          </div>
        </div>
      ))}
    </FeedPanel>
  );
};
